export const paperTheme = {
    background: (props) => props.theme.palette.surface,
    radiusVariant: {
        sm: {
            radius: (props) => props.theme.radius.unstable_new.sm,
            padding: (props) => props.theme.spacing.sm,
        },
        md: {
            radius: (props) => props.theme.radius.unstable_new.md,
            padding: (props) => props.theme.spacing.sm,
        },
        lg: {
            radius: (props) => props.theme.radius.unstable_new.lg,
            padding: (props) => props.theme.spacing.sm,
        },
        xl: {
            radius: (props) => props.theme.radius.unstable_new.xl,
            padding: (props) => props.theme.spacing.lg,
        },
    },
    depthVariant: {
        none: {
            shadow: 'none',
        },
        sm: {
            shadow: (props) => props.theme.shadow.sm,
        },
        md: {
            shadow: (props) => props.theme.shadow.md,
        },
        lg: {
            shadow: (props) => props.theme.shadow.lg,
        },
    },
};
export const radiusVariant = (borderRadius = 'md') => paperTheme.radiusVariant[borderRadius];
export const depthVariant = (depth = 'md') => paperTheme.depthVariant[depth];
